import React, { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import API from 'utils/API';
import { dateFormate, cellRendererCheck } from 'utils/columns';

const ProviderComment = ({ providerID, tenantID, coveredEntityID }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchProviderClaimComments();
  }, []);

  const fetchProviderClaimComments = async () => {
    try {
      const { data } = await API.get(
        `/${tenantID}/ceprovider/get/${coveredEntityID}/${providerID}`
      );
      setLoading(false);
      setData(data);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <Row className='align-items-center'>
        <Col md='auto' className='pe-3'>
          <p className='f-14 mb-0'>
            Provider Comments:
            <b className='d-inline-block ps-2 font-weight-500'>
              {data.comments || '-'}
            </b>
          </p>
        </Col>
      </Row>
      <Row className='align-items-center mt-2'>
        <Col sm='6' md='auto' className='pe-3'>
          <p className='f-14 mb-0'>
            Modified Date:
            <b className='d-inline-block ps-2 font-weight-500'>
              {dateFormate(data.modifiedDate)}
            </b>
          </p>
        </Col>
        <Col sm='6' md='auto' className='pe-3'>
          <p className='f-14 mb-0'>
            Modified By:
            <b className='d-inline-block ps-2 font-weight-500'>
              {cellRendererCheck(data.modifiedBy)}
            </b>
          </p>
        </Col>
      </Row>
    </>
  );
};

export default ProviderComment;
